// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__28ezl","noInteraction":"EventWrapper_noInteraction__2dvJ_","pointerPassthrough":"EventWrapper_pointerPassthrough__1ShRa"};